import { type ReactNode } from 'react';

import { CategoricalBarChartDataContext } from '../contexts/CategoricalBarChartDataContext.js';
import { useGenerateCategoricalBarData } from '../hooks/useGenerateCategoricalBarData.js';
import { CategoricalBarChartData } from '../types/categorical-bar-chart.js';

interface CategoricalBarChartProviderProps {
  children: ReactNode;
  data: CategoricalBarChartData[];
}

export const CategoricalBarDataProvider = ({
  data,
  children,
}: CategoricalBarChartProviderProps) => {
  const barData = useGenerateCategoricalBarData(data);

  return (
    <CategoricalBarChartDataContext.Provider value={barData}>
      {children}
    </CategoricalBarChartDataContext.Provider>
  );
};
